// import scripts
import './helpers';
// import './filter';


// import styles
import '../scss/main.scss';

(function($) {
    // alert('you are main');

    // function fixGutenbergPreview() {
    //     const gbGroup = $('.block-editor-block-list__block');
        
    //     console.log('yo')
    //     gbGroup.each( function () {
    //         if ($(this).find('.sm-col').length !== 0) {
    //             console.log($(this).find('.sm-col'));
    //         }
    //     })
    // }

    // fixGutenbergPreview();


    // $(document).on('ready', function () {
    //     fixGutenbergPreview();
    // })
})(jQuery)